import type { ReactNode } from 'react';

/**
 * O valor que a casa não tem, no lugar do dado.
 *
 * Nunca um traço, nunca vazio, nunca "—": vazio parece que a tela esqueceu de
 * carregar, e traço parece que o campo não existe. Estava escrito três vezes
 * (duas no portal, uma na interna), sempre igual.
 *
 * ## O texto é livre, e passou a ser em 09/09/2026
 *
 * "não informado" é o caso comum e continua sendo o padrão, mas a ausência tem
 * outras palavras conforme o campo: "ainda não atribuída", "sem prazo
 * definido", "não classificada". Elas existiam escritas à mão em `<span
 * className="text-texto-suave">` espalhados — a mesma peça, sem o nome dela, e
 * por isso livre para divergir no próximo lugar.
 *
 * ## `font-normal` não é detalhe
 *
 * Dentro de `DataRow` o valor é peso 600. Uma ausência no mesmo peso do dado
 * disputa a mesma atenção que ele, e a lista passa a ter quatro coisas fortes
 * em vez de duas — quem varre a tela lê "ainda não atribuída" com a ênfase de
 * um fato. Aqui ela volta ao peso do corpo, e o contraste continua sendo o do
 * texto de apoio, que é medido.
 */
export function NotProvided({ children }: { children?: ReactNode }) {
  return <span className="font-normal text-texto-suave">{children ?? 'não informado'}</span>;
}
